import React, { Component } from "react";
import {
  View,
  StyleSheet,
  Dimensions,
  Platform,
  TouchableHighlight,
} from "react-native";
// import Text from "./TextFont";
import Theme from "../argon-ui/Theme";
import { IconButton } from "./Buttons";
import * as CONSTANTS from "../../assets/consts";
import Spinner from "../components_v2/Spinner";
import { HStack, Text, VStack } from "native-base";
import { ArButton } from "../argon-ui";
import FontAwesomeIcon from "./FontAwesomeIcon";
import { getIsRTL } from "../util";

const SCREEN_WIDTH = Dimensions.get("screen").width;
const IS_MOBILE = Platform.OS === "android" || Platform.OS === "ios";
const LOADING_TIME = 4000;
class AreaItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fontsLoaded: false,
      selectedCameraId: undefined,
      subAction_1_IsLoading: false,
      subAction_2_IsLoading: false,
      isCameraViewSupported: true,
    };
    this._propSubIconStyles = this.props.subIconStyle || {};
  }

  handleSubAction1 = () => {
    this.setState({ subAction_1_IsLoading: true }, () => {
      setTimeout(() => {
        this.setState({ subAction_1_IsLoading: false });
      }, LOADING_TIME);
    });

    this.props.subAction1 && this.props.subAction1();
  };

  handleSubAction2 = () => {
    this.setState({ subAction_2_IsLoading: true }, () => {
      setTimeout(() => {
        this.setState({ subAction_2_IsLoading: false });
      }, LOADING_TIME);
    });
    this.props.subAction2 && this.props.subAction2();
  };

  handleOnCounterPress = () => {
    this.props.onCounterPress && this.props.onCounterPress();
  };

  render() {
    let subAction1 = null;
    let iconWrapperSize = 60;
    let iconSize = 22;
    let subIconColor = "#888"; // this.props.mainIconColor; //
    let captionColor = "#333333";
    let iconWrapperBackgroundColor = this.props.mainIconColor;
    if (
      typeof iconWrapperBackgroundColor === "string" &&
      iconWrapperBackgroundColor.startsWith("#")
    ) {
      if (iconWrapperBackgroundColor.length == 4)
        iconWrapperBackgroundColor += "2";
      else if (iconWrapperBackgroundColor.length == 7)
        iconWrapperBackgroundColor += "15";
    } else {
      iconWrapperBackgroundColor = "#0000"; // transparent
    }
    let subIconSize = 20;
    var _propStyles = this.props.style || {};

    if (this.props.subAction1_Icon) {
      subAction1 = (
        <View>
          {this.state.subAction_1_IsLoading ? (
            <View style={style.loadingContainer}>
              <Spinner size={subIconSize} />
            </View>
          ) : (
            <IconButton
              onPress={this.handleSubAction1}
              icon={{
                code: this.props.subAction1_Icon,
                style: {
                  fontFamily:
                    this.props.subAction1_Font || "FontAwesomeProLight",
                  fontSize: subIconSize,
                  color: subIconColor,
                },
              }}
              // caption={{ text: this.props.subAction1_Caption }}
            />
          )}
        </View>
      );
    } else if (this.props.subAction1_Caption) {
      subAction1 = (
        // <View style={style.subActionTextWrapper}>
        <ArButton
          variant="outline"
          _text={{
            fontSize: { base: "8px", md: "11px" },
            // color: Theme.COLORS.ACTIVE,
          }}
          onPress={this.handleSubAction1}
          isLoading={this.state.subAction_1_IsLoading}
          isDisabled={this.state.subAction_2_IsLoading}
          size="sm"
          style={{
            height: 33,
            flex: 1,
            marginBottom: 0,
            padding: 0,
            // borderColor: Theme.COLORS.ACTIVE,
          }}
        >
          {this.props.subAction1_Caption}
        </ArButton>
      );
    }
    let subAction2 = null;
    if (this.props.subAction2_Icon) {
      subAction2 = (
        <View style={style.areaItemActionWrapper}>
          {this.state.subAction_2_IsLoading ? (
            <View style={style.loadingContainer}>
              <Spinner size={subIconSize} />
            </View>
          ) : (
            <IconButton
              onPress={this.handleSubAction2}
              icon={{
                code: this.props.subAction2_Icon,
                style: {
                  fontFamily:
                    this.props.subAction2_Font || "FontAwesomeProLight",
                  fontSize: subIconSize,
                  color: subIconColor,
                },
              }}
              // caption={{ text: this.props.subAction2_Caption }}
            />
          )}
        </View>
      );
    } else if (this.props.subAction2_Caption) {
      subAction2 = (
        <ArButton
          variant="outline"
          size="xs"
          _text={{ fontSize: { base: "8px", md: "11px" } }}
          onPress={this.handleSubAction2}
          isLoading={this.state.subAction_2_IsLoading}
          isDisabled={this.state.subAction_1_IsLoading}
          style={{ height: 33, flex: 1, marginBottom: 0, padding: 0 }}
        >
          {this.props.subAction2_Caption}
        </ArButton>
      );
    }

    if (this.props.isKioskMode) {
      return (
        <TouchableHighlight
          underlayColor={Theme.COLORS.BACKGROUND}
          onPress={this.handleOnCounterPress}
          style={[
            style.menuDeviceItem,
            this.props.activeItem
              ? { backgroundColor: this.props.mainIconColor + "30" }
              : {},
          ]}
        >
          <VStack space="3" alignItems="center">
            <HStack space="1.5">
              <FontAwesomeIcon
                icon={this.props.mainIcon}
                size={18}
                color={
                  this.props.activeItem
                    ? this.props.mainIconColor
                    : Theme.COLORS.GRAY_DARK
                }
                // color={Theme.COLORS.WHITE}
                // style={{ marginEnd: 5, marginTop: 8 }}
              />
              {/* <Text style={{ color: Theme.COLORS.MUTED }}>({count})</Text> */}
            </HStack>
            <Text
              style={{
                color: this.props.activeItem
                  ? Theme.COLORS.DARK
                  : Theme.COLORS.MUTED,
                // color: Theme.COLORS.WHITE,
                flex: 1,
                fontSize: 9,
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              {this.props.caption}
            </Text>
          </VStack>
        </TouchableHighlight>
      );
    }
    return (
      <TouchableHighlight
        underlayColor={Theme.COLORS.WHITE}
        onPress={this.handleOnCounterPress}
        style={[
          IS_MOBILE ? style.areaItemWrapper : webStyle.areaItem,
          _propStyles,
          IS_MOBILE &&
            this.props.isKioskMode && { width: (SCREEN_WIDTH - 65) / 6 },
          // style.boxShadow
        ]}
      >
        {/* {subAction1} */}
        {/* center column */}
        <View style={{ flex: 1 }}>
          <View
            style={{
              flexDirection: "column",
              flex: 1,
              alignItems: "center",
            }}
          >
            {/* title and counter */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                paddingTop: 25,
                width: "100%",
              }}
            >
              <Text
                style={{
                  fontSize: 14,
                  color: captionColor,
                  flex: 1,
                  textAlign: "center",
                }}
              >
                {this.props.caption}
              </Text>
              {/* badge */}
              {this.props.count == 1 && this.props.statusColor ? (
                <View
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: 4,
                    backgroundColor: this.props.statusColor,
                    // position: "absolute",
                    top: -10,
                    right: 0,
                    shadowColor: this.props.statusColor,
                    shadowOffset: {
                      width: 0,
                      height: 5,
                    },
                    shadowOpacity: 0.2,
                    shadowRadius: 5.62,
                    elevation: 7,
                  }}
                />
              ) : (
                <View
                  style={[
                    style.badge,
                    {
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      paddingHorizontal: 5,
                      position: "absolute",
                      top: 0,
                      right: 0,
                    },
                  ]}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      color: "#666666",
                      fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "",
                    }}
                  >
                    {this.props.count}
                  </Text>
                  {this.props.countFull !== undefined && (
                    <Text
                      style={{
                        fontSize: 14,
                        color: "#666666",
                        fontFamily: getIsRTL() ? "IRANSansWebFaNum" : "",
                      }}
                    >
                      {this.props.countFull + " / "}
                    </Text>
                  )}
                </View>
              )}
            </View>
            <View
              style={{
                position: "relative",
                // backgroundColor: this.props.mainIconColor + 0.15 * 100,
                justifyContent: "center",
                alignItems: "center",
                width: iconWrapperSize,
                height: iconWrapperSize,
                backgroundColor: "#fff",
                borderRadius: 36,
                padding: 5,
                marginVertical: 15,
                marginBottom: 10,
                transform: [{ rotate: this.props.mainIconRotate || "0deg" }],
              }}
            >
              <FontAwesomeIcon
                size={iconSize}
                icon={this.props.mainIcon}
                color={this.props.mainIconColor}
              />
            </View>
            <HStack
              space="2"
              style={{
                justifyContent: "space-between",
                width: "100%",
                marginTop: subAction1 || subAction2 ? 15 : 0,
                //paddingHorizontal: 5,
              }}
            >
              {subAction1}
              {subAction2}
            </HStack>
          </View>
        </View>
        {/* {subAction2} */}
      </TouchableHighlight>
    );
  }
}

const style = StyleSheet.create({
  areaItemWrapper: {
    backgroundColor: "#f8f8f8aa",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#ebebeb",
    padding: 10,

    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-around",
    width: (SCREEN_WIDTH - 65) / 2,
    marginBottom: 8,
  },
  areaItemActionWrapper: {
    minWidth: 35,
    alignItems: "center",
    justifyContent: "flex-start",
  },
  badge: {
    fontSize: 14,
    color: "#666666",
    //borderRadius: 13,
    //width: 26,
    minWidth: 25,
    height: 25,
    borderRadius: 12,
    borderWidth: 1,
    // borderLeftWidth: 0,
    // borderRightWidth: 0,
    borderColor: "#cccccc",
    fontFamily: "IRANSansWebFaNum",
    textAlign: "center",
    backgroundColor: Theme.COLORS.WHITE,
    // position: "absolute",
    // top: -10,
    // alignSelf: "flex-end",
    // marginEnd: 15,
    // marginBottom: -35,
  },
  subActionTextWrapper: {
    marginTop: 10,
    backgroundColor: Theme.COLORS.MUTED + "20",
    borderColor: Theme.COLORS.MUTED + "30",
    color: Theme.COLORS.ACTIVE,
    borderWidth: 1,
    borderRadius: 5,
    paddingHorizontal: 4,
    height: 30,
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  boxShadow: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,

    elevation: 5,
  },
  loadingContainer: { width: 50, height: 25 },
  subActionText: {
    color: Theme.COLORS.ACTIVE,
    // fontSize: WINDOW_WIDTH / 100,
  },
  menuDeviceItem: {
    padding: 8,
    borderRadius: 10,
  },
});

const webStyle = StyleSheet.create({
  areaItem: {
    backgroundColor: "#f8f8f8aa",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#e2e2e2",
    padding: 10,
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: 8,
    width:
      (Math.min(SCREEN_WIDTH, CONSTANTS.WEB_MAX_WIDTH) -
        (SCREEN_WIDTH < CONSTANTS.WEB_MAX_WIDTH ? 60 : 300)) /
      2,
  },
});

export default AreaItem;
